import { useOrderGetList } from 'api/requests';
import { useQueryListData } from 'hooks';
import { generatePath, ROUTES } from 'libs/navigation';
import { TableSetRowHref } from 'libs/ui';
import { useOwner } from 'modules/account/common/hooks/useOwner';

import { OrdersListItem } from '../types';

const LIMIT = 50;

export const useOrders = () => {
  const { ownerId, ownerType } = useOwner();
  const {
    list: orders,
    rowCount,
    loading,
    setFilter,
    sort,
    page,
    filter,
    onPaginationChange,
    onSortChange,
  } = useQueryListData(useOrderGetList, {
    limit: LIMIT,
    filterParams: [],
    params: {
      ownerId,
      ownerType,
    },
  });

  const setRowHref: TableSetRowHref<OrdersListItem> = (order) =>
    generatePath(ROUTES.account.orders.order.fullPath, {
      orderId: order.id,
    });

  // GMT+5 (Алматы)
  // TODO: Feature request to get broker timezone offset from API
  const brokerTimezoneOffset = 18000;

  return {
    orders,
    loading: loading && !orders.length,
    sort,
    page,
    rowCount,
    limit: LIMIT,
    filter,
    brokerTimezoneOffset,
    setFilter,
    setRowHref,
    onSortChange,
    onPaginationChange,
  };
};
